/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_PulseInputs */



/**
* | output |
* | --- |
* | "Pulse weekly readout" |
*
* @param {Pricing_Compare_PulseInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_pulse = /** @type {((inputs?: Pricing_Compare_PulseInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_PulseInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Еженедельный отчёт Pulse")
	return /** @type {LocalizedString} */ ("Pulse weekly readout")
});